import { YES_FLAG, NO_FLAG } from '../../shared/constants';

export const frequencyOptions = [
  { label: 'One Time', value: NO_FLAG },
  { label: 'Recurring', value: YES_FLAG },
];

export const annualCumulativeOptions = [
  { label: YES_FLAG, value: YES_FLAG },
  { label: NO_FLAG, value: NO_FLAG },
];
